export interface SubsidyDetails {
  balance: number;
  currency: string;
  holderName: string;
  logoUrl?: string;
  endDate?: string;

  groupName: string;
  validDaysTimes?: string[];
  recurrence?: string;
  subsidyType: SubsidyType;
}

export interface ValidDayTime {
  day: string;
  timeRange: string;
}

export enum SubsidyType {
  Rollover = 'Rollover',
  TopOff = 'Top Off',
}
